export default __webpack_public_path__ + "img/ic-no-image.png";